export default __webpack_public_path__ + "static/media/video.2fff87c6.svg";